import React from 'react';
import classNames from 'classnames';
import testimonialAvatar from './testimonial-avatar.jpg';

import { LoginType } from '@mm/state/controllers/SessionController';
import { Link } from '@mm/components';

import { SignUpLogo } from '../../../../../dashboard/pages/SignUp/SignUp/SignUpLogo/SignUpLogo';

import { Badges } from '../components/Badges/Badges';

import css from './FunnelProLayout.module.css';
import { useAuthBtn } from '../use-auth-btn';

type Props = {
  className?: string;
  children?: any;
};

export const FunnelProLayout = ({ className, children }: Props) => {
  const { authBtnText, authLinkDestination, isSignUp } = useAuthBtn(
    LoginType.funnelpro,
  );

  return (
    <div className={classNames(className, css.wrapper)}>
      <div className={css.background}>
        <div className={css.left} />
        <div className={css.right} />
      </div>

      <div className={css.container}>
        <div className={css.navbar}>
          <SignUpLogo className={css.logo} />
          <Link className={css.login} to={authLinkDestination}>
            {authBtnText}
          </Link>
        </div>

        <div className={css.content}>
          <div className={css.section}>
            <div className={css.description}>
              <span className={css.headline}>
                Engage and convert prospects across the messaging channels they
                use every day
              </span>

              <span className={css.subtitle}>
                FunnelPro is the OmniChatⓇ marketing platform for B2C marketers
                and advertisers that keeps sales pipelines full
              </span>

              <div className={css.testimonial}>
                <div className={css.avatar}>
                  <img src={testimonialAvatar} alt="Cat Howell" />
                </div>
                <div className={css.info}>
                  <span className={css.name}>Neil Patel</span>
                  <span className={css.position}>NeilPatel.com</span>
                  <span className={css.mark}>“</span>
                  <p className={css.quote}>
                    Messaging automation amplifies your marketing reach,
                    advertising return, and customer support efficiency.
                    <br />
                    MobileMonkey is the only platform that allows marketers to
                    make Facebook ad bots, SMS bots, and native web chat bots in
                    one place.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={css.section}>
            <div className={css.card}>
              <Badges
                className={classNames(css.badges, {
                  [css.centeredBadges]: !isSignUp,
                })}
                isSignUp={isSignUp}
              />
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
